import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    transition: 'all 100ms ease-in-out',
  },
  child: {
    marginTop: 15,
    backgroundColor: theme.palette.divider,
    width: '60%',
    borderRadius: theme.shape.borderRadius * 2,
    borderBottomRightRadius: 0,
    padding: 15,
    paddingBottom: 5,
    '& h4': {
      color: theme.palette.primary.main,
    },
    '& p': {
      color:
        theme.palette.type === 'dark' ? '#fff' : theme.palette.text.primary,
    },
    '@media (min-width: 1441px)': {
      width: '45%',
    },
  },
  header: {
    display: 'flex',
    paddingBottom: 7,
    marginBottom: 7,
    justifyContent: 'space-between',
    cursor: 'pointer',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    padding: '0 10px',
    '& p': {
     opacity: 0.5,
     margin: 3,
    },
  },
}))

export default useStyles
